export const shortDateFormat = (dateValue: string) => {
  let formattedDate = "";
  const timestamp = new Date(dateValue).getTime();
  if (isNaN(timestamp) && dateValue) {
    const [day, month, year] = dateValue.split("/");
    const formattedDateStr = `${month}/${day}/${year}`;
    formattedDate = new Date(formattedDateStr).toLocaleDateString("en-GB");
  } else {
    formattedDate = new Date(timestamp).toLocaleDateString("en-GB");
  }

  return formattedDate;
};

export function getWorkingDays(
  startDate: Date,
  endDate: Date,
  excludedDates: Date[]
): number {
  let count = 0;
  let currentDate = new Date(startDate);
  let finalDate = new Date(endDate);
  let multiplier = 1;

  if (startDate > endDate) {
    currentDate = new Date(endDate);
    finalDate = new Date(startDate);
    multiplier = -1;
  }

  while (currentDate <= finalDate) {
    const dayOfWeek = currentDate.getDay();
    if (
      dayOfWeek !== 0 &&
      dayOfWeek !== 6 && // 0 = Sunday, 6 = Saturday
      !excludedDates.includes(currentDate)
    ) {
      count++;
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return count * multiplier;
}

export function toUTC(date: Date): Date {
    return new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ));
}
